export const LEGACY_ORDENES_PAGO_LISTA =
  process.env.REACT_APP_API_ADMINOPBASE_LISTA || "/api/adminordenpagobase/lista";

export const LEGACY_ORDENES_PAGO_PDF =
  process.env.REACT_APP_API_ADMINOPBASE_PDF || "/api/adminordenpagobase/pdf";

export const formatLegacyOrdenPagoDate = (value) => {
  if (!value) return "";
  if (/^\d{2}-\d{2}-\d{4}$/.test(String(value))) {
    return String(value);
  }

  const [year, month, day] = String(value).split("-");
  if (!year || !month || !day) {
    return String(value);
  }

  return `${day}-${month}-${year}`;
};
